import React from "react";
import { CartoonImageWebSocketProvider } from "./context/CartoonWebSocket";
import { ImageSocketProvider } from "./context/ImageWebSocket";
import { VideoSocketProvider } from "./context/VideoWebSocket";
import { CreditPointsProvider } from "./services/CreditPointsProvider";
import { PodcastProvider } from "./context/PodcastProvider";
import { AIInfluencerCharacterProvider } from "./context/AIInfluencerCharacterProvider";
import { AIInfluencerVariationProvider } from "./context/AIInfluencerVariationProvider";
import { PhototTalksProvider } from "./context/PhotoTalksProvider";
import { ProductScapeProvider } from "./context/ProductScapeWebsocket";
import { ShowcaseProvider } from "./context/ShowcaseProvider";
import { AudioProvider } from "./context/AudioProvider";
import { AudioProviderRampWalk } from "./context/RampWalkAudioProvider";
import { ReelsProvider } from "./context/ReelWebSocketProvider";
import { RampWalkProvider } from "./context/RampWalkWebSocket";
import { AudioProviderVoiceClone } from './context/VoiceProvider';


interface AppProvidersProps {
  userId: string;
  cartoonImage: string;
  modelIdImage: string;
  modelIdVideo: string;
  podcastId: string;
  children: React.ReactNode;
  AIInfluencerCharacter: string;
  AIInfluencerVariation: string;
  photoTalksId: string; 
  productScapeId: string;
  showcaseId: string;
  audioId: string;
  reelsId: string;
  rampId: string;
  audioIdRamp: string;
  voiceId: string;

}

export default function AppProviders({
  userId,
  cartoonImage,
  modelIdImage,
  modelIdVideo,
  podcastId,
  AIInfluencerCharacter,
  AIInfluencerVariation,
  photoTalksId,
  productScapeId,
  showcaseId,
  audioId,
  reelsId,
  rampId,
  audioIdRamp,
  voiceId,

  children,
}: AppProvidersProps) {
  return (
    <CartoonImageWebSocketProvider userId={userId} modelId={cartoonImage}>
      <ImageSocketProvider userId={userId} modelId={modelIdImage}>
        <VideoSocketProvider userId={userId} modelId={modelIdVideo}>
          <AudioProviderVoiceClone userId={userId} modelId={voiceId} mediaType="audio">
          <PodcastProvider userId={userId} modelId={podcastId} mediaType="video">
            <AIInfluencerCharacterProvider userId={userId} modelId={AIInfluencerCharacter} mediaType="image">
              <AIInfluencerVariationProvider userId={userId} modelId={AIInfluencerVariation} mediaType="image">
                <PhototTalksProvider userId={userId} modelId={photoTalksId} mediaType="video">
                  <ProductScapeProvider userId={userId} modelId={productScapeId} mediaType="image">
                   <ShowcaseProvider userId={userId} modelId={showcaseId} mediaType="image">
                    <AudioProvider userId={userId} modelId={audioId} mediaType="audio">
                      <AudioProviderRampWalk userId={userId} modelId={audioIdRamp} mediaType="audio">
                      <ReelsProvider userId={userId} modelId={reelsId} mediaType="video">
                        <RampWalkProvider userId={userId} modelId={rampId} mediaType="video">
                <CreditPointsProvider>
                  {children}
                </CreditPointsProvider>
                </RampWalkProvider>
                </ReelsProvider>
                </AudioProviderRampWalk>
                </AudioProvider>
                </ShowcaseProvider>
                </ProductScapeProvider>
                </PhototTalksProvider>
              </AIInfluencerVariationProvider>
            </AIInfluencerCharacterProvider>
          </PodcastProvider>
          </AudioProviderVoiceClone>
        </VideoSocketProvider>
      </ImageSocketProvider>
    </CartoonImageWebSocketProvider>
  );
}
